export default `
:root {
  --main-color: #2d6558;
  --main-color-light: #659086;
  --white: #e5e5e5;
  --black: #1e1e1e;

  --main-border-color: var(--main-color);
  --secondary-border-color: var(--main-color);

  --colored-background: var(--main-color);
  --white-background: var(--white);
  --background-color: #1d1415;
}
`
